import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-[var(--color-bg-elevated)] text-[var(--color-text-secondary)] border border-[var(--color-border-subtle)]',
        amber: 'bg-[var(--color-accent-amber-dim)] text-[var(--color-accent-amber)]',
        green: 'bg-[var(--color-accent-green-dim)] text-[var(--color-accent-green)]',
        red: 'bg-[var(--color-accent-red-dim)] text-[var(--color-accent-red)]',
        blue: 'bg-blue-500/15 text-[var(--color-accent-blue)]',
        violet: 'bg-violet-500/15 text-[var(--color-accent-violet)]',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
